import { inject, Injectable } from '@angular/core';
import {MatSnackBar, MatSnackBarModule} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationSnack {
  private snackBar = inject(MatSnackBar);
  private errorHard: boolean = false;
  private messageError: string;

  public setErrorHard(value:boolean){
    this.errorHard = value;
  }

  public setMessage(txt: string){
    this.messageError = txt;
  }

  public getError(){
    return this.errorHard;
  }

  display() {
    this.snackBar.open(this.messageError, 'Close', {
      panelClass: '',
      duration: 30000
    });
    this.errorHard = false;
  }
}
